var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      attrs: {
        "no-caret": "",
        variant: "link",
        "toggle-class": "p-1 text-muted item-actions-toggle",
        "menu-class": "item-actions-dropdown-menu",
        boundary: "window",
        "popper-opts": { positionFixed: true },
        right: "",
      },
      on: {
        show: function ($event) {
          return _vm.$emit("open")
        },
        hide: function ($event) {
          return _vm.$emit("close")
        },
      },
      nativeOn: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _c("MoreHorizontalIcon", { attrs: { width: 16, height: 16 } }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.editItem.apply(null, arguments)
            },
          },
        },
        [
          _c("PencilIcon", {
            staticClass: "mr-2",
            attrs: { width: 14, height: 14 },
          }),
          _vm._v("\n    Rename\n  "),
        ],
        1
      ),
      _vm._v(" "),
      _vm.canCustomize
        ? _c(
            "b-dropdown-item",
            {
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.customizeItem.apply(null, arguments)
                },
              },
            },
            [
              _c("PaletteIcon", {
                staticClass: "mr-2",
                attrs: { width: 14, height: 14 },
              }),
              _vm._v("\n    Customize...\n  "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canCustomize ? _c("b-dropdown-divider") : _vm._e(),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          attrs: { "link-class": "text-danger" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.deleteItem.apply(null, arguments)
            },
          },
        },
        [
          _c("Trash2Icon", {
            staticClass: "mr-2",
            attrs: { width: 14, height: 14 },
          }),
          _vm._v("\n    Delete\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }